(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["category-tree"] && !Shopify.designMode) return;
  try {
    /* SPH: same localized alphabetic ordering for sidebar brand collections
     and the matching right-hand category cards. Changes DOM order as well
     as appearance, preserving keyboard/focus reading sequence. */
  function sphSortBrandCollections(scope) {
    var locale = document.documentElement.lang || 'en';
    var collator;
    try {
      collator = new Intl.Collator(locale, { sensitivity: 'base', numeric: true });
    } catch (e) {
      collator = new Intl.Collator('en', { sensitivity: 'base', numeric: true });
    }
    scope.querySelectorAll('.category-tree, .subcategory-grid').forEach(function (container) {
      var items = Array.from(container.children).filter(function (item) {
        return item.hasAttribute('data-sph-brand-sort');
      });
      if (items.length < 2) return;
      var group = items[0].getAttribute('data-sph-brand-group');
      if (!group || items.some(function (item) {
        return item.getAttribute('data-sph-brand-group') !== group;
      })) return;
      items.sort(function (a, b) {
        var last = Number(a.getAttribute('data-sph-brand-last') === '1') -
          Number(b.getAttribute('data-sph-brand-last') === '1');
        if (last) return last;
        var name = collator.compare(
          a.getAttribute('data-sph-brand-sort') || '',
          b.getAttribute('data-sph-brand-sort') || ''
        );
        return name || collator.compare(
          a.getAttribute('data-sph-brand-id') || '',
          b.getAttribute('data-sph-brand-id') || ''
        );
      });
      items.forEach(function (item) { container.appendChild(item); });
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    sphSortBrandCollections(document);
    const toggleButtons = document.querySelectorAll('.category-toggle');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const item = this.closest('.category-item');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', String(!isExpanded));
        item.classList.toggle('expanded');
      });
    });

    const activeLinks = document.querySelectorAll('.category-link.active');
    activeLinks.forEach((activeLink) => {
      let parent = activeLink.closest('.category-item');
      while (parent) {
        const toggle = parent.querySelector(':scope > .category-toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          parent.classList.add('expanded');
        }
        parent = parent.parentElement?.closest('.category-item');
      }
    });
  });
  document.addEventListener('shopify:section:load', function (event) {
    sphSortBrandCollections(event.target);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sph-sidebar-backup-2026-10-09-group1"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.category-toggle');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const item = this.closest('.category-item');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', String(!isExpanded));
        item.classList.toggle('expanded');
      });
    });

    const activeLinks = document.querySelectorAll('.category-link.active');
    activeLinks.forEach((activeLink) => {
      let parent = activeLink.closest('.category-item');
      while (parent) {
        const toggle = parent.querySelector(':scope > .category-toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          parent.classList.add('expanded');
        }
        parent = parent.parentElement?.closest('.category-item');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sph-sidebar-backup-before-ES-IT-PT-2026-10-09"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.category-toggle');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const item = this.closest('.category-item');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', String(!isExpanded));
        item.classList.toggle('expanded');
      });
    });

    const activeLinks = document.querySelectorAll('.category-link.active');
    activeLinks.forEach((activeLink) => {
      let parent = activeLink.closest('.category-item');
      while (parent) {
        const toggle = parent.querySelector(':scope > .category-toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          parent.classList.add('expanded');
        }
        parent = parent.parentElement?.closest('.category-item');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sph-sidebar-backup-before-FI-NO-2026-10-09"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.category-toggle');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const item = this.closest('.category-item');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', String(!isExpanded));
        item.classList.toggle('expanded');
      });
    });

    const activeLinks = document.querySelectorAll('.category-link.active');
    activeLinks.forEach((activeLink) => {
      let parent = activeLink.closest('.category-item');
      while (parent) {
        const toggle = parent.querySelector(':scope > .category-toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          parent.classList.add('expanded');
        }
        parent = parent.parentElement?.closest('.category-item');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sph-sidebar-backup-before-RO-SV-DA-2026-10-09"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.category-toggle');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const item = this.closest('.category-item');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', String(!isExpanded));
        item.classList.toggle('expanded');
      });
    });

    const activeLinks = document.querySelectorAll('.category-link.active');
    activeLinks.forEach((activeLink) => {
      let parent = activeLink.closest('.category-item');
      while (parent) {
        const toggle = parent.querySelector(':scope > .category-toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          parent.classList.add('expanded');
        }
        parent = parent.parentElement?.closest('.category-item');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sph-sidebar-backup-before-dynamic-sort-2026-10-09"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.category-toggle');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const item = this.closest('.category-item');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', String(!isExpanded));
        item.classList.toggle('expanded');
      });
    });

    const activeLinks = document.querySelectorAll('.category-link.active');
    activeLinks.forEach((activeLink) => {
      let parent = activeLink.closest('.category-item');
      while (parent) {
        const toggle = parent.querySelector(':scope > .category-toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          parent.classList.add('expanded');
        }
        parent = parent.parentElement?.closest('.category-item');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sph-sidebar-backup-before-future-proof-2026-10-09"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.category-toggle');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const item = this.closest('.category-item');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', String(!isExpanded));
        item.classList.toggle('expanded');
      });
    });

    const activeLinks = document.querySelectorAll('.category-link.active');
    activeLinks.forEach((activeLink) => {
      let parent = activeLink.closest('.category-item');
      while (parent) {
        const toggle = parent.querySelector(':scope > .category-toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          parent.classList.add('expanded');
        }
        parent = parent.parentElement?.closest('.category-item');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sph-sidebar-backup-before-id-hierarchy-2026-10-09"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.category-toggle');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const item = this.closest('.category-item');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', String(!isExpanded));
        item.classList.toggle('expanded');
      });
    });

    const activeLinks = document.querySelectorAll('.category-link.active');
    activeLinks.forEach((activeLink) => {
      let parent = activeLink.closest('.category-item');
      while (parent) {
        const toggle = parent.querySelector(':scope > .category-toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          parent.classList.add('expanded');
        }
        parent = parent.parentElement?.closest('.category-item');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sph-sidebar-backup-before-root-labels-2026-10-09"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.category-toggle');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const item = this.closest('.category-item');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', String(!isExpanded));
        item.classList.toggle('expanded');
      });
    });

    const activeLinks = document.querySelectorAll('.category-link.active');
    activeLinks.forEach((activeLink) => {
      let parent = activeLink.closest('.category-item');
      while (parent) {
        const toggle = parent.querySelector(':scope > .category-toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          parent.classList.add('expanded');
        }
        parent = parent.parentElement?.closest('.category-item');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sph-sidebar-backup-category-tree-2026-10-08"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.category-toggle');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const item = this.closest('.category-item');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', String(!isExpanded));
        item.classList.toggle('expanded');
      });
    });

    const activeLinks = document.querySelectorAll('.category-link.active');
    activeLinks.forEach((activeLink) => {
      let parent = activeLink.closest('.category-item');
      while (parent) {
        const toggle = parent.querySelector('.category-toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          parent.classList.add('expanded');
        }
        parent = parent.parentElement?.closest('.category-item');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sph-sidebar-before-promo-removal-2026-10-09"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.category-toggle');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const item = this.closest('.category-item');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', String(!isExpanded));
        item.classList.toggle('expanded');
      });
    });

    const activeLinks = document.querySelectorAll('.category-link.active');
    activeLinks.forEach((activeLink) => {
      let parent = activeLink.closest('.category-item');
      while (parent) {
        const toggle = parent.querySelector(':scope > .category-toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          parent.classList.add('expanded');
        }
        parent = parent.parentElement?.closest('.category-item');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sph-sidebar-pre-accessibility-2026-10-08"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const toggleButtons = document.querySelectorAll('.category-toggle');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const item = this.closest('.category-item');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', String(!isExpanded));
        item.classList.toggle('expanded');
      });
    });

    const activeLinks = document.querySelectorAll('.category-link.active');
    activeLinks.forEach((activeLink) => {
      let parent = activeLink.closest('.category-item');
      while (parent) {
        const toggle = parent.querySelector(':scope > .category-toggle');
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'true');
          parent.classList.add('expanded');
        }
        parent = parent.parentElement?.closest('.category-item');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
